import React from 'react'

const ExpertTraining = () => {
  return (
    <div>ExpertTraining</div>
  )
}

export default ExpertTraining